<template>
    <div class="container-fluid">
        <h1
            class="page-title"
            v-if="!template.id"
        >
            New Email Template
        </h1>
        <h1
            class="page-title"
            v-if="template.id"
        >
            Edit Email Template
        </h1>
        <div class="card">
            <div class="card-body">
                <form
                    action=""
                    @submit.prevent="save()"
                >
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label for="name">Name</label>
                                <input
                                    type="text"
                                    required
                                    id="name"
                                    placeholder="Name"
                                    v-model="template.name"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.name }"
                                    disabled
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.name"
                                >{{ errors.name[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="from">From Address</label>
                                <input
                                    type="email"
                                    required
                                    id="from"
                                    placeholder="name@email.com"
                                    v-model="template.from"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.from }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.from"
                                >{{ errors.from[0] }}</small>
                            </div>

                            <div class="form-group">
                                <label for="subject">Subject</label>
                                <input
                                    type="text"
                                    required
                                    id="subject"
                                    placeholder="Subject"
                                    v-model="template.subject"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.subject }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.subject"
                                >{{ errors.subject[0] }}</small>
                            </div>

                            <div class="form-group">
                                <label for="content">Content</label>
                                <textarea
                                    required
                                    id="content"
                                    placeholder="Message content here..."
                                    v-model="template.content"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.content }"
                                    rows="20"
                                />
                                <small
                                    class="form-error"
                                    v-if="errors.content"
                                >{{ errors.content[0] }}</small>
                                <small>Footer is added automatically</small>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <button
                                type="submit"
                                class="btn btn-primary"
                            >
                                Save
                            </button>

                            <activity-log
                                v-if="template.id"
                                :id="template.id"
                                model="EmailTemplate"
                            />

                            <button
                                type="button"
                                @click="$router.go(-1)"
                                class="btn btn-outline-secondary"
                            >
                                Back
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Service from "../../../services/EmailTemplatesService";

export default {
    props: ["id"],
    data: function() {
        return {
            template: {},
            errors: {}
        };
    },
    mounted: function() {
        if (this.id) {
            Service.get(this.id).then(
                res => {
                    this.template = res.data;
                },
                err => {
                    alert("Error: Could not load template");
                }
            );
        }
    },
    methods: {
        save: function() {
            this.errors = {};
            if (this.template.id) {
                Service.update(this.template).then(
                    res => {
                        this.template = res.data;
                        alert("Template saved");
                    },
                    err => {
                        this.errors = err.response.data.errors;
                    }
                );
            }
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/email-templates/EditComponent.vue